import { render, staticRenderFns } from "./SaveWizardModal.vue?vue&type=template&id=c77ec430&"
import script from "./SaveWizardModal.vue?vue&type=script&lang=js&"
export * from "./SaveWizardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports